import React from 'react'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import './index.scss'

interface SongwriterCatalogEmptyWarningProps {
    currentSongwriterId: string
}
const SongwriterCatalogEmptyWarning = ({ currentSongwriterId }: SongwriterCatalogEmptyWarningProps) => (
    <div className="songwriter-empty-catalog">
        <p>
            <strong>You have nothing here</strong>
        </p>
        <p>Get started now by searching The MLC database to find your works (songs).</p>
        <Button mainColor typeLink type="primary" linkTo={Navigation.songwriter.catalogBuilder(currentSongwriterId)}>
            Build Your Catalog
        </Button>
    </div>
)

export default SongwriterCatalogEmptyWarning
